import { Modal } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const WaiterDeliveryAlertWppContainer = styled(Modal)`
  width: fit-content;
  height: fit-content;
`